export const apiPath = '/v1/users';
const actionType = 'USER_ASSETS';

export default actionType;
